module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (40).736b4247.jpg";